import type { AnalyticsEvent } from './types';

export const fireGtmEvent = <T extends object>(
  event: AnalyticsEvent,
  properties: T,
): void => {
  window.dataLayer ||= [];
  window.dataLayer.push({ event, ...(properties as Record<string, unknown>) });
};

// This is distinct from "fireGtmEvent" as it does not try to control the event name
export const fireDeferredGtmEvent = <T extends object>(
  event: string,
  properties: T,
) => {
  window.dataLayer ||= [];
  window.dataLayer.push({ event, ...(properties as Record<string, unknown>) });
};

export const setGtagUserId = (userId: string | null): void => {
  window.gtag('set', { user_id: userId });
};
